import React, { useState } from 'react';
import { KeyIcon } from '@patternfly/react-icons';
import { ChangePasswordModal } from '@app/AppLayout/ChangePasswordModal';

const Settings: React.FunctionComponent = () => {
    const [showChangePassword, setShowChangePassword] = useState(false);

    return (
        <div style={{ padding: '32px', maxWidth: '800px' }}>
            <h1 style={{ fontSize: '24px', fontWeight: 700, color: '#1f2937', margin: '0 0 8px 0' }}>
                Settings
            </h1>
            <p style={{ fontSize: '14px', color: '#6b7280', margin: '0 0 32px 0' }}>
                Manage your account preferences
            </p>

            {/* Security Section */}
            <div style={{
                background: '#ffffff',
                borderRadius: '16px',
                border: '1px solid #e5e7eb',
                overflow: 'hidden'
            }}>
                <div style={{
                    padding: '20px 24px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <div style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '10px',
                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#ffffff',
                            fontSize: '18px'
                        }}>
                            <KeyIcon />
                        </div>
                        <div>
                            <h2 style={{ fontSize: '16px', fontWeight: 600, color: '#1f2937', margin: 0 }}>
                                Password
                            </h2>
                            <p style={{ fontSize: '13px', color: '#6b7280', margin: '2px 0 0 0' }}>
                                Update your account password
                            </p>
                        </div>
                    </div>
                    <button
                        onClick={() => setShowChangePassword(true)}
                        style={{
                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            color: '#ffffff',
                            border: 'none',
                            padding: '8px 20px',
                            fontSize: '14px',
                            fontWeight: 600,
                            borderRadius: '8px',
                            cursor: 'pointer',
                            boxShadow: '0 2px 8px rgba(102, 126, 234, 0.3)',
                            transition: 'all 0.2s ease'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.boxShadow = '0 4px 14px rgba(102, 126, 234, 0.5)';
                            e.currentTarget.style.transform = 'translateY(-1px)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.boxShadow = '0 2px 8px rgba(102, 126, 234, 0.3)';
                            e.currentTarget.style.transform = 'translateY(0)';
                        }}
                    >
                        Change Password
                    </button>
                </div>
            </div>

            <ChangePasswordModal
                isOpen={showChangePassword}
                onClose={() => setShowChangePassword(false)}
            />
        </div>
    );
};

export { Settings };
